import { render, staticRenderFns } from "./差異分析Header.vue?vue&type=template&id=35c1afd0&scoped=true&"
import script from "./差異分析Header.ts?vue&type=script&lang=ts&"
export * from "./差異分析Header.ts?vue&type=script&lang=ts&"
import style0 from "./差異分析Header.css?vue&type=style&index=0&id=35c1afd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c1afd0",
  null
  
)

export default component.exports